import React from 'react';
import './Header.css';
import fbIcon from './fbIcon.jpg';
import spIcon from './logo_SPH.PNG';
import cpuIcon from './logo_CPU.PNG';
import igIcon from './igIcon.jpg';
import youtubeIcon from './youtubeIcon.jpg';

export default function Footer (props) {

    return (
        <footer style={{ 'background': '#10793e', 'height': '10vh', 'minHeight': '150px' }}>
            <p className="text-center" style={{ 'color': 'white' }}>Follow us</p>
            <div className="d-flex justify-content-center">
				<img style={{ 'margin': '10px' }} alt="fb" src={fbIcon} width="25" height="25" />
                <a style={{ 'margin-left': '20px', 'margin-right': '20px'}} href="https://www.facebook.com/sportshouse/posts/10157522582371371" rel="noopener noreferrer" target="_blank">
					<img alt="fb" src={spIcon} height="45" />
				</a>
                <a href="https://www.facebook.com/CPUHK" rel="noopener noreferrer" target="_blank">
					<img alt="ig" src={cpuIcon} height="45" />
				</a>
            </div>
			<div className="d-flex justify-content-center">
                <img style={{ 'margin': '10px' }} alt="ig" src={igIcon} width="25" height="25" />
                <a style={{ 'margin-left': '20px', 'margin-right': '20px'}} href="https://www.instagram.com/sportshouse_hk/" rel="noopener noreferrer" target="_blank">
					<img alt="fb" src={spIcon} height="45" />
				</a>
				<a href="https://www.instagram.com/cpu_hk/" rel="noopener noreferrer" target="_blank">
					<img alt="ig" src={cpuIcon} height="45" />
				</a>
            </div>
        </footer>
    );
}
